import './FlagList.scss'
import CountryDataManager from "../Data/country-manager"
import { useEffect, useRef, useState } from "react"


function FlagList(props: { selected: string | null, langcode: string, onClick: (e: any) => void }) {

  const [isoCodes, setIsoCodes] = useState([] as string[])

  const countryDataInstance = useRef(null as CountryDataManager|null)
  useEffect(() => {
    (async () => {
      const instance = await CountryDataManager.getInstance()
      countryDataInstance.current = instance
      setIsoCodes(instance.getCountriesList())
    })();
  }, [])



  return (
    <div className="flag-grid">
      {isoCodes.map((isoCode: string) => {
        const countryData = countryDataInstance.current?.getCountry(isoCode, props.langcode)
        if(countryData != null) {
          return (<div key={countryData.iso_code} onClick={() => props.onClick(countryData.iso_code)} className={`country-flag ${props.selected === countryData.iso_code ? 'selected' : ''}`}>
            <div className="flag">
              <img src={countryData.flag_url} alt={countryData.name} title={countryData.name} />
            </div>
            <div className="country-name">
              <span style={{ marginTop: 0 }}>{countryData.name}</span>
            </div>
          </div>)
        }
        return <></>
      })}
    </div>
  )
}

export default FlagList